import { Box, Container, FormControl, Input, Typography } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleBoxButton, StyleBoxContainer } from './style';
import { useSendEmailMutation } from 'services/authCompany';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { Breadcrumb } from 'apps/company/components';
import useTitle from 'hooks/useTitle';

function ForgotPassword(props) {
  const { t } = useTranslation();
  const [ success, setSuccess ] = useState(false);
  useTitle(t('common:pageTitle:forgotPassword'));
  const schema = yup.object().shape({
    email: yup
      .string()
      .required(t('validate:requiredEmail'))
      .max(255, t('validate:oversizedEmail'))
      .email(t('validate:invalidEmail')),
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ 
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const [sendMail, { isLoading }] = useSendEmailMutation();

  const watchEmail = watch('email', '');

  function handleSentMail(data) {
    sendMail(data)
      .unwrap()
      .then()
      .catch(() => {})
      .finally(() => {
        setSuccess(true)
      });
  }

  if (!success) {
    return (
      <Container>
        <Breadcrumb content={t('forgotPassword:title')} bottom={24}></Breadcrumb>
        <Typography weight={400}>{t('forgotPassword:description')}</Typography>
        <Box pt={48}>
          <form>
            <FormControl error={errors.email}>
              <Input
                placeholder={t('forgotPassword:inputEmail')}
                {...register('email')}
              />
            </FormControl>
          </form>
        </Box>
        <Box justifyContent={'center'} display={'flex'} pt={48}>
          <StyleBoxButton
            variant="contained"
            disabled={!watchEmail || isLoading}
            onClick={handleSubmit(handleSentMail)}
          >
            {t('forgotPassword:sendMail')}
          </StyleBoxButton>
        </Box>
      </Container>
    );
  }
  return (
    <StyleBoxContainer>
      <Typography variant="breadcrumb" weight={600}>{ t('forgotPassword:sendMailSuccessfully') }</Typography>
      <Typography variant="default" weight={400}>{ t('forgotPassword:sendMailNote') }</Typography>
    </StyleBoxContainer>
  )
}

export default ForgotPassword;
